/*
 * @Description: 
 * @Author: DXV-RGWU-TUFH-RFCY-IEGMYY
 * @Date: 2021-07-04 00:16:14
 * @LastEditTime: 2023-12-11 14:53:03
 * @LastEditors: DXV-RGWU-TUFH-RFCY-IEGMYY
 */

import Vue from 'vue'
import TopNav from './topNav.vue'
import LbButton from './lbButton.vue'
import LbSwitch from './lbSwitch.vue'
import LbTips from './lbTips.vue'
import LbPage from './lbPage.vue'
import LbClassifyTitle from './lbClassifyTitle.vue'
import LbUpload from './lbUpload.vue'
import LbToolTips from './lbToolTips.vue'
import LbUploadCover from './lbUploadCover.vue'
import LbUeditor from './lbUeditor.vue'
import LbCover from './lbCover.vue'
import LbImage from './lbImage.vue'
import LbMap from './lbMap.vue'
import LbIdentify from './lbIdentify'
import lbEditImg from './lbEditImg'
import lbSlider from './lbSlider'
import lbTechnicianInfo from './lbTechnicianInfo'
import lbServiceInfo from './lbServiceInfo'
import lbRefundOrder from './lbRefundOrder'
Vue.component('top-nav', TopNav)
Vue.component('lb-button', LbButton)
Vue.component('lb-switch', LbSwitch)
Vue.component('lb-tips', LbTips)
Vue.component('lb-page', LbPage)
Vue.component('lb-classify-title', LbClassifyTitle)
Vue.component('lb-upload', LbUpload)
Vue.component('lb-tool-tips', LbToolTips)
Vue.component('lb-upload-cover', LbUploadCover)
Vue.component('lb-ueditor', LbUeditor)
Vue.component('lb-cover', LbCover)
Vue.component('lb-image', LbImage)
Vue.component('lb-map', LbMap)
Vue.component('lb-identify', LbIdentify)
Vue.component('lb-edit-img', lbEditImg)
Vue.component('lb-slider', lbSlider)
Vue.component('lb-technician-info', lbTechnicianInfo)
Vue.component('lb-service-info', lbServiceInfo)
Vue.component('lb-refund-order', lbRefundOrder)



// WEBPACK FOOTER //
// ./src/components/basics/index.js